/*@ngInject*/
const RowController = function ($scope, $element, fieldType) {

    $element.addClass('formRow');

    this.$onInit = () => {
        this.containsSupplementalForm = !_.isEmpty(this.row.formName);
    };

    this.shouldRemoveIndent = function (rowStructure) {
        let fieldStructureList = rowStructure.fieldStructureList,
            hasOneField = fieldStructureList ? fieldStructureList.length === 1 : true,
            field = fieldStructureList ? fieldStructureList[0] : null,
            fieldTemplateType = field ? field.uiField.fieldTemplate.type : -1,
            isLabelField = fieldTemplateType === fieldType.LABEL,
            isRowRepeater = fieldTemplateType === fieldType.ROWREPEATER,
            isSupplementalForm = rowStructure.formName;

        return (isLabelField && hasOneField && !isRowRepeater) || isSupplementalForm;
    };

};

angular.module('umFormViewer')
    .controller('rowController', RowController);
